module.exports = __webpack_public_path__ + "static/img/btn_downloadPDF.a1a3d98.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn_downloadPDF.png
// module id = E1dQ
// module chunks = 0